// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"6a4d8aab","672":"b4da07fd","780":"e75c92a2","787":"a0fe7c63"}[chunkId] + ".chunk.js";
};